import { FieldValues, Path, UseFormSetError } from 'react-hook-form'

import { ValidationResponse } from 'entities/ticket/ui/purchase-from/model.ts'

export const getValidationError = <T extends FieldValues>(
  data: ValidationResponse,
  setError: UseFormSetError<T>,
): Path<T> | null => {
  let firstError: Path<T> | null = null

  data.passengers?.forEach((passenger) => {
    const { age, index, ...fields } = passenger

    Object.entries(fields).forEach(([field, message]) => {
      if (!message) return

      const name = `${age}.${index}.${field}` as Path<T>
      setError(name, { type: 'server', message })

      if (!firstError) {
        firstError = name
      }
    })
  })

  return firstError
}

export const getValidationErrorContact = <T extends FieldValues>(
  data: ValidationResponse,
  setError: UseFormSetError<T>,
) => {
  if (data.email) {
    setError('email' as Path<T> as Path<T>, {
      type: 'server',
      message: data.email,
    })
  }

  if (data.phone_number) {
    setError('phone_number' as Path<T>, {
      type: 'server',
      message: data.phone_number,
    })
  }
}
